/**
 * Default animation configurations for charts
 */

export const DEFAULT_ANIMATIONS = {
  appear: {
    duration: 800,
    easing: 'cubicOut'
  },
  update: {
    duration: 500,
    easing: 'cubicOut'
  }
};

// Animation presets for different chart types
export const CHART_ANIMATIONS = {
  bar: {
    appear: {
      animation: 'growHeightIn',
      duration: 800,
      easing: 'cubicOut'
    }
  },
  line: {
    appear: {
      animation: 'progressiveIn',
      duration: 1000,
      easing: 'cubicOut'
    }
  },
  area: {
    appear: {
      animation: 'fadeIn',
      duration: 800,
      easing: 'cubicOut'
    }
  },
  pie: {
    appear: {
      animation: 'growAngleIn',
      duration: 800,
      easing: 'cubicOut'
    }
  }
}; 